// 智能监控——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `monitor/index${i + 1}`,
  name: `monitorIndex${i + 1}`,
  component: () => import(`@/views/smartLife/monitor/index${i + 1}.vue`)
}))



export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 智能监控——主流程，开始
    ...MainRoutes,

  ],
};
